import { Select, Space, Typography } from 'antd';
import _ from 'lodash';
import { useOrderSearchForTicket } from 'modules/CreateTicket/store';
import { filterOption } from 'modules/utilities/utility';
import React, { useEffect, useState } from "react";

function AssigneeFilter({ selectedAssignee, setSelectedAssignee, selectedCategory, selectedSubCategory }) {
  const { crmCategories } = useOrderSearchForTicket();
  const [assigneeOptions, setAssigneeOptions] = useState()
  useEffect(() => {
    let assignee = crmCategories.map(category => category.subcategory).flat();

    if (selectedSubCategory && !_.isEmpty(selectedSubCategory)) {
      assignee = assignee.filter(subcategory => selectedSubCategory.includes(subcategory.value));
    } else if (selectedCategory && !_.isEmpty(selectedCategory)) {
      assignee = crmCategories.filter(category => selectedCategory.includes(category.value)).map(category => category.subcategory).flat();
    }

    assignee = assignee?.map(subcategory => subcategory.assignees).flat().map(assignee => ({ label: assignee.firstName, value: assignee.userId }));
    const uniqueAssignee = assignee.reduce((acc, user) => ({ ...acc, [user.value]: user }), {});
    const options = Object.values(uniqueAssignee);
    setAssigneeOptions(options);
  }, [selectedCategory, selectedSubCategory])

  const handleSelect = data => setSelectedAssignee(data);
  return (
    <Space.Compact block className='my-2'>
      <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }} className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
        <Typography.Text>Select Assignees</Typography.Text>
      </span>
      <Select
        mode='multiple'
        style={{ width: '70%' }}
        showSearch
        allowClear
        placeholder='Assignees'
        optionFilterProp='children'
        value={selectedAssignee}
        onChange={handleSelect}
        filterOption={filterOption}
        options={assigneeOptions}
      />
    </Space.Compact>
  );
}

export default AssigneeFilter;
